module.exports = __webpack_public_path__ + "img/Seccion-3.9bf8a5aa.png";